import { Injectable } from '@angular/core';

@Injectable()
export class CPS {
  empty : any                   = () => { return 0; }
  constructor() {
  }
  sequence(...cpsFunctions: any[]) {
    function recSequence( index : number, obj : any, ctn : any, fArgs : any[] ) {
      if (index >= cpsFunctions.length) return ctn.apply( obj, fArgs );
      fArgs.unshift( function(...fArgsr: any[]) {
        return recSequence( index+1, this, ctn, fArgsr );
      } );
      return cpsFunctions[ index ].apply( obj, fArgs );
    };
    return function( ctn : any, ...fArgs: any[] ) {
      return recSequence( 0, this, ctn, fArgs );
    };

  }
  ifthenelseS(iffn : any,thenfn : any, elsefn : any) {
    return (ctn) => {
      if (iffn(this.empty)) return thenfn( ctn );
      else return elsefn( ctn );
    }
  }
  test() {
    let incr                    = (ctn,i) => { return ctn(i+1); };
    let writer                  = (ctn,i) => { return console.log("CPS writer: "+i.toString()); };
    this.sequence(
      incr
      , incr
      , incr
      , incr
      , writer
    )(() => { return 0; }, 0);
  }
}



// WEBPACK FOOTER //
// ./src/providers/cps.ts